var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"questions-answer__box"},[_c('container',[_c('Questions',{attrs:{"ques":_vm.questions}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }